import cn from 'classnames'
import React, { ComponentProps, ReactElement, useId } from 'react'

import style from './NotesInputField.style'

type NotesInputFieldProps = {
  id?: string
  fieldLabel?: React.ReactElement | string
  showUpdates?: boolean
  baseValue?: string
  value?: string
  onChange: (value: string) => void
  placeholder: string
  type?: string
  disabled?: boolean
  autoComplete?: string
  name?: string
  maxLength?: number
  notesCharacters?: number
  showSaving?: boolean
  setShowSaving?: (val: boolean) => void
  variant?: 'default' | 'severe'
  required?: boolean
} & Omit<ComponentProps<'div'>, 'onChange' | 'children'>

function NotesInputField(props: NotesInputFieldProps): ReactElement {
  const {
    className = '',
    variant = 'default',
    onChange: onValueChange,
    ...rest
  } = props

  const reactId = useId()
  const textareaId = props.id || reactId

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ): void => {
    onValueChange(e.target.value)
    if (!props.showSaving) props.setShowSaving?.(true)
  }

  return (
    <div className={cn('NotesInputField', className)} css={style} {...rest}>
      {props.fieldLabel !== undefined && (
        <label htmlFor={textareaId} className="NotesInputField-label">
          {props.fieldLabel}
        </label>
      )}
      <div className="NotesInputField-container">
        {/* TODO: potentially used {...rest} here */}
        <textarea
          id={textareaId}
          className={cn('NotesInputField-textarea', variant)}
          data-testid={'notesInput'}
          placeholder={props.placeholder}
          value={props.value}
          onChange={handleChange}
          disabled={props.disabled}
          autoComplete={props.autoComplete || 'off'}
          name={props.name}
          inputMode={props.inputMode}
          maxLength={props.maxLength}
          aria-required={props.required || undefined}
        />
        {props.maxLength !== undefined && (
          <div className="NotesInputField-counter">
            {`${props.notesCharacters || 0}/${props.maxLength}`}
          </div>
        )}
      </div>
    </div>
  )
}

export default NotesInputField
